/**
 * ProductTileSkeleton — loading placeholder matching the tile's visual structure.
 *
 * Ported from hec-composable/hec/components/product-tile-cms/productTileSkeleton.tsx
 */
import { Skeleton } from "~/components/ui/skeleton";

export function ProductTileSkeleton() {
  return (
    <div className="flex h-full w-full flex-col">
      {/* Product Image */}
      <Skeleton
        className="aspect-square rounded-md"
        data-testid="productTileSkeleton"
      />
      {/* Stars + Ratings text */}
      <div className="mt-2 flex space-x-2">
        <Skeleton
          className="h-6 w-1/2 rounded-md"
          data-testid="productTileSkeleton"
        />
        <Skeleton
          className="h-6 w-1/2 rounded-md"
          data-testid="productTileSkeleton"
        />
      </div>
      {/* Product Name */}
      <Skeleton
        className="mt-2 h-8 w-full rounded-md"
        data-testid="productTileSkeleton"
      />
      {/* Price */}
      <Skeleton
        className="mt-2 h-5 w-1/3 rounded-md"
        data-testid="productTileSkeleton"
      />
      {/* Quantity + Add to Cart */}
      <div className="mt-2 flex space-x-2">
        <Skeleton
          className="h-12 w-1/2 rounded-md"
          data-testid="productTileSkeleton"
        />
        <Skeleton
          className="h-12 w-1/2 rounded-md"
          data-testid="productTileSkeleton"
        />
      </div>
    </div>
  );
}
